<template>
  <div class="van-card">
    <div>
      <h3 v-text="data.name">春季上新 Nova say Hi</h3>
      <p>主售包：搭售包比例={{data.aBussRatioQty}}:{{data.bBussRatioQty}} 每人限购{{data.maxLimitQty}}组</p>
      <p>活动时间：{{data.beginTime}}-{{data.endTime}}</p>
    </div>
    <h3>主售商品包</h3>
    <template v-if="data.aGoods.length>0">
      <div class="card"
           v-for="item in data.aGoods"
           :key="item.skuName">
        <div class="card-header">
          产品名称： {{ item.goodsName }}
          <!--          <van-checkbox v-model="item.checked"></van-checkbox>-->
        </div>
        <div class="card-body">
          <div class="line">
            <label class="label">SKU名称:</label>
            {{ item.skuName }}

          </div>
          <div class="line">
            <label class="label">SKU编码:</label>
            {{ item.skuCode }}
            <label class="label">商品单价:</label>
            <small style="color: #f11826">￥{{ item.amount }}</small>
          </div>
        </div>
        <div class="card-footer">
          <div>
            <label class="label">分货数量:</label> {{ item.stock }}
          </div>
          <div>
            <label class="label">可购数量:</label> {{ item.availableStockQty }}
          </div>
          <div><label class="label">购买数量:</label>
            <input type="number" class="number-input" :disabled="item.availableStockQty==0" v-model.number="item.buyNum"/>
          </div>
        </div>
      </div>
    </template>
    <h3>搭售商品包</h3>
    <template v-if="data.bGoods.length>0">
      <div class="card"
           v-for="item in data.bGoods"
           :key="item.skuCode">
        <div class="card-header">
          产品名称： {{ item.goodsName }}
          <!--          <van-checkbox v-model="item.checked"></van-checkbox>-->
        </div>
        <div class="card-body">
          <div class="line">
            <label class="label">SKU名称:</label>
            {{ item.skuName }}

          </div>
          <div class="line">
            <label class="label">SKU编码:</label>
            {{ item.skuCode }}
            <label class="label">商品单价:</label>
            <small style="color: #f11826">￥{{ item.amount }}</small>
          </div>
        </div>
        <div class="card-footer">
          <div>
            <label class="label">分货数量:</label> {{ item.stock }}
          </div>
          <div>
            <label class="label">可购数量:</label> {{ item.availableStockQty }}
          </div>
          <div><label class="label">购买数量:</label>
            <input type="number" class="number-input" v-model.number="item.buyNum"/>
          </div>
        </div>
      </div>
    </template>
    <!--    <van-empty v-else description="暂无分货"></van-empty>-->
  </div>
</template>

<script>
import {genBuySkuInfo} from "@/api/direct-purchase";

export default {
  props: {
    data: {
      type: Object,
      default: () => ({
        "areaTyingId": "",
        "name": "xxx",
        "beginTime": "2022-06-13 07:01:50",
        "endTime": "2022-06-13 07:01:50",
        "maxLimitQty": 0,
        "ratioLocked": false,
        "tips": "",
        "shopId": 0,
        "aRatioQty": 0,
        "bRatioQty": 0,
        "aGoods": [
          {
            "goodsName": "xxx",
            "skuCode": "000",
            "skuName": "xxxx",
            "batchId": "",
            "batchName": "",
            "stock": 0,
            "availableStockQty": 0,
            "amount": 0.00
          }
        ],
        "bGoods": [
          {
            "goodsName": "",
            "skuCode": "",
            "skuName": "",
            "batchId": "",
            "batchName": "",
            "stock": 0,
            "availableStockQty": 0,
            "amount": 0.00
          }
        ]
      })
    }
  },
  methods:{
    async listBuySku(){
      let aCheckGoods = this.data.aGoods.filter(o=>o.buyNum>0)
      let bCheckGoods = this.data.bGoods.filter(o=>o.buyNum>0)
      // 比例化简
      let aRatioQty = this.data.aBussRatioQty;
      let bRatioQty = this.data.bBussRatioQty;
      let len = aRatioQty>bRatioQty?bRatioQty:aRatioQty;
      let lcm = 1;
      for(let i=1;i<=len;i++){
        if(aRatioQty%i==0&&bRatioQty%i==0){
          lcm = i
        }
      }

      aRatioQty = aRatioQty/lcm
      bRatioQty = bRatioQty/lcm
      console.log(aRatioQty,bRatioQty)
      //check max
      let aBuyQty = aCheckGoods.map(o=>o.buyNum).reduce((x,y)=>x+y,0)
      let bBuyQty = bCheckGoods.map(o=>o.buyNum).reduce((x,y)=>x+y,0)
      let aTotalQty = this.data.aGoods.map(o=>o.availableStockQty).reduce((x,y)=>x+y,0)
      let bTotalQty = data.bGoods.map(o=>o.availableStockQty).reduce((x,y)=>x+y,0)
      console.log(aBuyQty, bBuyQty)
      if(aTotalQty!=0 || bTotalQty!=0){
        if(aBuyQty==0){
          return Promise.reject("请加购主售机型")
        }
        if(bBuyQty==0){
          return Promise.reject("请加购搭售机型")
        }
        let overfllow = aCheckGoods.filter(o=>o.buyNum>o.availableStockQty)
        if(overfllow.length){
          return Promise.reject(overfllow.map(o=>o.skuName).join(",")+" 请检查加购数量")
        }
        overfllow = bCheckGoods.filter(o=>o.buyNum>o.availableStockQty)
        if(overfllow.length){
          return Promise.reject(overfllow.map(o=>o.skuName).join(",")+" 请检查加购数量")
        }
        if(aBuyQty/aRatioQty>this.data.maxLimitQty){
          return Promise.reject("不能超限购上限")
        }
        //check ratio
        //check lock-ratio
        if(this.data.ratioLocked){
          if(aBuyQty/aRatioQty!=bBuyQty/bRatioQty){
            return Promise.reject("请按"+aRatioQty +':'+bRatioQty+"比例加购")
          }
        }else {
            if(aBuyQty/aRatioQty<bBuyQty/bRatioQty){
              return Promise.reject("请按最低"+aRatioQty +':'+bRatioQty+"比例加购")
            }
        }
      }else {
        if(aTotalQty==0&&bBuyQty==0){
          return Promise.reject("请加购搭售机型")
        }
        if(bTotalQty==0&&aBuyQty==0){
          return Promise.reject("请加购主售机型")
        }
        console.log("主售商品已空")
      }

    /*  let buy = {
        id: this.data.shopId,
        name: this.data.shopName
      };
      buy.commodity = this.listBuySku().map(sku => ({
        title: sku.goodsName,
        standard: sku.skuName,
        count: sku.buyNum,
        price: sku.amount,
        // thumb: this.goods.picture,
        thumb: sku.picture,
        skuCode: sku.code,
        shopId: this.goods.shopId,
        skuId: sku.id,
        goodsId: this.id
      }));
      bus.state.buyList = [buy];*/
      let d = [...aCheckGoods,...bCheckGoods].map(o=>({skuCode:o.skuCode,buyNum:o.buyNum,shopId:this.data.shopId}))
      return (await genBuySkuInfo(d)).data
    }
  }
}
</script>
<style lang="less" scoped>
.van-card {
  margin: 5px 5px 20px;
  box-shadow: 5px 5px 3px #ddd;
}

.card {
  background: #fff;
  padding: 0 10px;
  margin: 5px 5px 20px;
  border-radius: 5px;
  font-size: 14px;
  //box-shadow: 5px 5px 3px #ddd;
  border: 1px solid #eee;
  color: #333;

  .card-header {
    padding: 0 10px;
    height: 50px;
    line-height: 50px;
    border-bottom: 1px solid #eee;
    display: flex;
    justify-content: space-between;
  }

  .card-body {
    padding: 10px;
    font-size: 12px;
  }

  .card-footer {
    padding: 0 10px;
    height: 50px;
    line-height: 50px;
    border-top: 1px solid #eee;
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 12px;
  }

  .line {
    height: 30px;
    line-height: 30px;
  }

  .label {
    color: #999;
    margin-right: 10px;
  }

  .number-input {
    width: 60px;
    height: 30px;
    line-height: 30px;
    border-radius: 15px;
    padding: 0 10px;
    box-sizing: border-box;
    border: 1px solid #999;

    &[readonly='readonly'] {
      background: #eee;
    }
  }

  .van-tag {
    margin-left: 10px;
  }
}
</style>